export const QueryKeys = {
    GetAllOrganisations: 'get-all-organisations',
    GetOrganisationById: 'get-organisation-by-id',
}
